module.exports = __webpack_public_path__ + "img/84600.efa860b2.jpg";